import { DomainItems, ModifyDomainFn } from '@devexpress/dx-react-chart';
import { getDateDiffInDays } from 'globals/utils';

export interface FsTrendChartSingleRowDataProps {
  x: number;
  income?: number;
  outgoing?: number;
  balance?: number;
}

export const getInitialDayRange = (
  chartData: FsTrendChartSingleRowDataProps[]
): number => {
  const rangeStart = chartData[0].x;
  const endStart = chartData[chartData.length - 1].x;
  return getDateDiffInDays(rangeStart, endStart);
};

export const getZoomLevel = (
  initialDayRange: number,
  actualDayRange: number
): number => {
  return Math.round((initialDayRange / actualDayRange) * 100) / 100;
};

let executed = false;
export const modifyDomain: ModifyDomainFn = ([
  bottomThreshold,
  topThreshold,
]: DomainItems): DomainItems => {
  if (!executed) {
    executed = true;
    return [bottomThreshold, topThreshold];
  }
  // this function is being called twice ( not sure why - probably some MaterialUI Chart bag )
  // we do threshold recalculations, so we want work on final values, and not do recalculations twice
  const newBottomThreshold = Math.floor(bottomThreshold) - 0.1;
  const newTopThreshold = Math.ceil(topThreshold) + 0.1;
  return [newBottomThreshold, newTopThreshold];
};

export default {};
